module.exports = __webpack_public_path__ + "static/media/jetpure-4.ea8a468c.jpg";